import Image from 'next/image';
import { useRouter } from 'next/router';
import { UiButton, UiText } from 'znanie-uikit';

import BroadcastStatusMark from 'components/widget/BroadcastStatus';

import { IVideoPlayer } from '../index';

import { useBroadcastsStatus } from 'hooks/utils/useBroadcastsStatus';

import css from './BlurVideoPlayerCover.module.scss';

enum EPath {
  Library = '/library/video/[slug]',
  Event = '/events/[slug]',
}

export default function BlurVideoPlayerCover({
  coverUrl,
  broadcasts,
  onRegister,
}: IVideoPlayer) {
  const { pathname } = useRouter();

  const broadcastsStatus = useBroadcastsStatus(broadcasts || []);

  const showAuth = () => ZnanieSDK.showAuth();

  return (
    <div className={css.unauthorized}>
      {pathname === EPath.Event && (
        <div className={css.onlineMark}>
          <BroadcastStatusMark settings={broadcastsStatus} />
        </div>
      )}
      <Image
        src={coverUrl || ''}
        layout="fill"
        objectFit="cover"
        quality={100}
        alt=""
      />
      <div className={css.info}>
        <UiText
          as="p"
          color="white"
          weight="normal"
          size="large"
          className={css.infoText}
        >
          {pathname === EPath.Library &&
            'Видеоматериалы доступны только для зарегистрированных пользователей'}
          {pathname === EPath.Event &&
            'Запишитесь на мероприятие, чтобы присоединиться к трансляции'}
        </UiText>
        <div className={css.actions}>
          {pathname === EPath.Library && (
            <>
              <UiButton
                variant="outline"
                fluid
                type="button"
                className={css.signUp}
                onClick={showAuth}
              >
                Зарегистрироваться
              </UiButton>
              <UiButton
                variant="secondary"
                fluid
                type="button"
                className={css.signIn}
                onClick={showAuth}
              >
                Войти
              </UiButton>
            </>
          )}
          {pathname === EPath.Event && (
            <UiButton variant="secondary" type="button" onClick={onRegister}>
              Записаться
            </UiButton>
          )}
        </div>
      </div>
    </div>
  );
}
